import React from 'react';
import cn from 'classnames';
import { MATERIAL_TRANSITION_TIME } from 'swag-client-common/constants';
import { isMobileFilter } from 'swag-client-common/utils/ui.utils';
import { Button } from 'swag-client-common/components/ui/button';
import Drawer from '../../ui/drawer';
import { isAllSwagCategory } from '../../../redux/product-listing/product-listing.utils';
import { FilterButton } from './components/filter-button';
import DrawerMiddleBlock from './components/drawer-middle-block';
import FilterList from './components/filter-list';
import classes from './filters.scss';
class Filters extends React.Component {
  render() {
    const {
      onOpen,
      isOpen,
      onClose,
      currentCategory,
      FilterItemComponent,
      productAttributes,
      categories,
      colorFamily,
      pricing,
      productionTime,
      minQuantity,
      isLoading,
      headerTitle,
      shouldShowBackLink,
      withAnimation = true,
      primaryColor = '',
      secondaryColor = '',
      isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS
    } = this.props;
    const variant = isMobileFilter() ? 'temporary' : 'persistent';
    const transitionTime = withAnimation ? MATERIAL_TRANSITION_TIME : 0;
    return /*#__PURE__*/React.createElement("div", null, !categoriesAndFiltersAreHiddenForCBS && /*#__PURE__*/React.createElement(FilterButton, {
      onClick: onOpen,
      secondaryColor: secondaryColor,
      primaryColor: primaryColor,
      onClose: onClose
    }), /*#__PURE__*/React.createElement(Drawer, {
      open: categoriesAndFiltersAreHiddenForCBS ? false : isOpen,
      variant: variant,
      onClose: onClose,
      headerTitle: "Filters",
      paperClassName: cn(classes.paper),
      headerClassName: classes.headerTitle,
      dataDrawer: "FiltersDrawer",
      anchor: "left",
      closeClassName: classes.closeButton,
      bodyClassName: cn(classes.body, {
        [classes.filterBody]: !!currentCategory,
        [classes.marginTop20]: !!currentCategory,
        [classes.allSwagFiltersHolderHeight]: isAllSwagCategory()
      }),
      fullHeightHolder: true,
      MiddleBlock: headerTitle && /*#__PURE__*/React.createElement(DrawerMiddleBlock, {
        shouldShowBackLink: shouldShowBackLink,
        headerTitle: headerTitle
      }),
      containerClassName: classes.filterHolder,
      transitionTime: transitionTime
    }, /*#__PURE__*/React.createElement(FilterList, {
      minQuantity: minQuantity,
      productionTime: productionTime,
      pricing: pricing,
      colorFamily: colorFamily,
      categories: categories,
      productAttributes: productAttributes,
      isLoading: isLoading,
      FilterItemComponent: FilterItemComponent,
      shouldShowBackLink: shouldShowBackLink,
      secondaryColor: secondaryColor,
      onClose: onClose,
      isCuratedBrandStore: isCuratedBrandStore,
      categoriesAndFiltersAreHiddenForCBS: categoriesAndFiltersAreHiddenForCBS
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.button,
      onClick: onClose,
      dataButton: "Apply"
    }, "Apply filters"))));
  }
}
export { Filters };